import { DataSource, Layout, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutServiceIncidentList extends Layout {
    searchpanela: SearchPanel;
    sourceServiceIncidentList: DataSource;
    switchApproved: Switch;
    switchReportable: Switch;
    switchReviewRequired: Switch;
    tableServiceIncidents: Table;
    textboxCustomerId: Textbox;
    textboxDispatcherUserId: Textbox;
    textboxEdiStandardCode2: Textbox;
    textboxEnteredDate: Textbox;
    textboxEnteredUserId: Textbox;
    textboxFleetManager: Textbox;
    textboxOperationsUser: Textbox;
    textboxOrderId: Textbox;
    textboxStatus: Textbox;
}
